import UserManagement from './main';
import { ROLES } from '../../common/auth/roles';

export const companyRoutes = [
  { name: 'User Management', path: '/company/user-management', minRole: ROLES.MANAGER, render: () => <UserManagement /> },
];